import React from 'react';
import PropTypes from 'prop-types';

import style from './page-layout.module.less';

const Header = ({ children = null }) => <div className={style.header}>{children}</div>;

Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
